import { Component, OnInit, AfterContentInit, Input, Output, EventEmitter, OnChanges, SimpleChange } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApplicationContextService, LocationService, ToCountryNamePipe } from 'lib-core-shared';
import { PhoneNumberUtil, PhoneNumber, PhoneNumberFormat } from 'google-libphonenumber';

import { Observable, Subject } from 'rxjs';

import { filter, map, catchError, finalize } from 'rxjs/operators';

import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { Pipe, PipeTransform } from '@angular/core';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'phone-number-input',
  templateUrl: './phone-number-input.component.html',
  styleUrls: ['./phone-number-input.component.scss'],
  providers: [ToCountryNamePipe]
})


export class PhoneNumberInputComponent implements OnInit {

  @Input() numberObj: any;
  @Input() isRequired?: boolean;
  @Input() size: any;
  @Input() label!: string;
  @Input() labelOpacity!: string;
  @Input() isRequiredField!: boolean;
  @Input() idName!: string;
  @Input() defaultCountryCode!: string | undefined;
  @Input() parentFormSubmitted: boolean = false;

  region: any;
  countryCodes: any;
  prioritiseCountries: any;

  phoneUtils: PhoneNumberUtil = PhoneNumberUtil.getInstance();
  PNF: any = PhoneNumberFormat;
  ph: any = PhoneNumber;

  phoneForm!: FormGroup;

  location!: Observable<any>;
  countryCode$!: Observable<any>;
  countryCodesFormatted: any = [];
  validNumber!: boolean;
  touched: boolean = false;

  @Output() formReady = new EventEmitter<FormGroup>();
  //create a formgroup, form control of phone input, if valueChanges, pass up event emitter to parent

  numberVerified: any;
  @Output() numberVerifiedEmit = new EventEmitter<boolean>();
  @Output() numberUpdated = new EventEmitter<any>();
  @Input() showValidationWarning!: boolean;

  @Input() returnDisplayNumber!: boolean;
  @Output() returnDisplayNumberEvent = new EventEmitter<any>();
  @Output() regionChanged = new EventEmitter<any>();

  @Input() parentSubject!: Subject<any>;

  constructor(private locationService: LocationService, private countryName: ToCountryNamePipe, private applicationContext: ApplicationContextService) {
    //PRIORITISE THESE ON DROPDOWN LIST
    this.prioritiseCountries = [{
      name: 'United Kingdom',
      region: 'gb',
      internationalCode: '44'
    },
    {
      name: 'United States',
      region: 'us',
      internationalCode: '1'
    },
    {
      name: 'France',
      region: 'fr',
      internationalCode: '33'
    },
    {
      name: 'Germany',
      region: 'de',
      internationalCode: '49'
    },
    {
      name: 'Netherlands',
      region: 'nl',
      internationalCode: '31'
    }]
  }

  ngOnInit() {
    this.initialize();
  }

  ngOnChanges(changes: any) {
    if (changes?.defaultCountryCode && changes?.defaultCountryCode.firstChange == false) {
      this.changeRegion(changes?.defaultCountryCode.currentValue);
    }

    if (changes?.numberObj && changes?.numberObj.firstChange == false) {
      if (changes?.numberObj?.previousValue?.number == null && changes?.numberObj?.currentValue?.number != null) {
        this.initialize()
      }
    }
  }

  initialize = () => {

    //if phone number is a string (and it's not empty) create an object to work with
    //else it will be left as a string
    if (typeof this.numberObj.number === 'string' && this.numberObj.number != '') {
      this.numberObj = {
        number: this.numberObj.number,
        displayNumber: null,
        default: this.numberObj.default
      }
    } else {
      this.numberObj = {
        number: '',
        displayNumber: null,
        default: this.numberObj.default
      }
    }

    //incase geolocation stalls before user action, like in ie
    this.region = this.defaultCountryCode;



    //set region
    //if this is a saved number get the region from the number
    if (this.numberObj && this.numberObj.number && this.numberObj.number != '') {

      let number: PhoneNumber = this.phoneUtils.parseAndKeepRawInput(this.numberObj.number, this.region);

      let regionCodeFromNumber = this.phoneUtils.getRegionCodeForNumber(number);

      if (regionCodeFromNumber) {
        this.region = this.phoneUtils.getRegionCodeForNumber(number)

        if (this.region) {
          this.region = this.region.toLowerCase();
        }
      }

      if (!this.region) {
        this.getCountryCode();
      }
      //else get the region from users location
    } else {
      this.getCountryCode();
    }

    this.phoneForm = new FormGroup({
      telephone: new FormControl(this.numberObj.number, [Validators.required]),
      region: new FormControl(this.region)
    })

    //update parent form
    this.formReady.emit(this.phoneForm);

    if (this.numberObj.number) {
      this.formatNumber(this.numberObj.number)
    }

    if (this.returnDisplayNumber) {
      this.returnDisplayNumberEvent.emit(this.numberObj)
    }

    //reset input
    if (this.parentSubject) {
      this.parentSubject
        .subscribe((res: any) => {
          this.numberObj = {
            number: '',
            displayNumber: null,
            default: false
          }
          this.phoneForm.controls.telephone.setValue('')
        })
    }

    if (!this.countryCodes) {
      this.countryCodes = this.phoneUtils.getSupportedRegions();

      this.countryCodes.forEach((cc: string) => {

        if (cc == '001') {
          //there's some bad data here(such as Universal International Freephone Service with dialing code 800) so skip these entries
        } else {
          let countryCode = {
            internationalCode: this.phoneUtils.getCountryCodeForRegion(cc),
            region: cc,
            regionLc: cc.toLowerCase(),
            name: this.countryName.transform(cc)
          }
          this.countryCodesFormatted.push(countryCode)
        }
      })

      this.countryCodesFormatted - this.countryCodesFormatted.sort((a: any, b: any) => a.name.localeCompare(b.name));
    }

  }

  formatNumber(e: any) {
    
    if (e) {
      let x = e.toString()
      //https://github.com/google/libphonenumber for examples of below
      try {
        let number: PhoneNumber = this.phoneUtils.parse(x, this.region);
        this.numberObj.displayNumber = this.phoneUtils.format(number, this.PNF.INTERNATIONAL);
        this.numberObj.number = this.phoneUtils.format(number, this.PNF.INTERNATIONAL);
        this.phoneForm.controls.telephone.setValue(this.numberObj.displayNumber);

        this.numberUpdated.emit(this.numberObj)
        this.numberVerified = this.phoneUtils.isValidNumberForRegion(number, this.region);
        this.numberVerifiedEmit.emit(this.numberVerified);
      }
      catch(e) {
        this.numberVerified = undefined;
        this.numberVerifiedEmit.emit(this.numberVerified);
      }
    } else {
      //if the input has been changed and now contains no number we should still notify the parent app so forms etc will become invalid
      if (this.numberObj.number) {
        this.numberUpdated.emit({ number: undefined })
      }

      this.phoneForm.controls.telephone.setValue(undefined);
    }
  }

  regionChange(region: any) {

    this.region = region;

    this.formatNumber(this.numberObj.number);

  }

  getCountryCode() {

    if (this.applicationContext.isPublic()) {

      this.locationService.getCountryCode(false)
        .subscribe((r: any) => {
          this.getUserLocation(r, false)
        }, (error: any) => {
          console.error(error);
          this.getCountryCodeByGivenCodeOrBranchContext();
        })

    } else {

      this.getCountryCodeByGivenCodeOrBranchContext();

    }
  }

  getUserLocation(url: string, restrictToBranches: boolean) {
    this.locationService.getCurrentPosition(url, restrictToBranches)
      .subscribe((response: any) => {
        if (response) {
          this.region = response;
        }
      })
  }

  getCountryCodeByGivenCodeOrBranchContext() {
    if (this.defaultCountryCode) {
      this.region = this.defaultCountryCode;
    } else if (this.applicationContext.isApplicationEmbedded()) {
      this.region = this.applicationContext.getBranchCodeFromUrl(true);
    } else {
      this.region = 'GB';
    }
  }

  changeRegion(r: any) {
    //update country selected
    this.region = r;
    this.phoneForm.controls.region.setValue(this.region);
    //a region update means the phone number needs to be reformatted
    if (this.numberObj) {
      this.regionChange(r)
    }

    this.regionChanged.emit(r);
  }

  ngOnDestroy() {
  }
}
